document.addEventListener('DOMContentLoaded', function() {
	const page = document.querySelector('.blog-single-item');
	if (!page) return;

	const anchors = page.querySelectorAll('a[href*="#"]');

	anchors.forEach((anchor)=> {
		anchor.addEventListener('click', (e)=> onCLick(e, anchor));
	});

	const onCLick = (e, anchor)=> {
		e.preventDefault();

		const blockID = anchor.getAttribute('href').replace('#', '');
		const block = document.getElementById(blockID);
		const blockPosition = (block.getBoundingClientRect().top + window.scrollY - 80);

		window.scrollTo({ top: blockPosition, behavior: 'smooth' });
	};
});
